// extracted by mini-css-extract-plugin
export default {"searchContainer":"_searchbar_searchContainer__IbIFF"};